import React from 'react'
import PropTypes from 'prop-types'

import * as s from './InputField.module.scss'

const InputField = ({
  id,
  name,
  type,
  onChange,
  onBlur,
  value,
  labelText,
  error,
}) => {
  return (
    <>
      <label htmlFor={id} className={s.label}>
        <p className={s.labelText}>{labelText}</p>
        <input
          id={id}
          name={name}
          type={type}
          className={s.input}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
        />
      </label>
      {error && (
        <div className={s.error}>
          <p className={s.errorText}>{error}</p>
        </div>
      )}
    </>
  )
}

export default InputField

InputField.defaultProps = {
  error: '',
}

InputField.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onBlur: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
  labelText: PropTypes.string.isRequired,
  error: PropTypes.string,
}
